export const style = {
  boxContainer: {
    padding: '0px 16px',
    width: 290,
    position: 'fixed',
    top: 120,
    left: 0,
    zIndex: 900,
    '& svg': {
      fontSize: 20,
      lineHeight: 20,
      display: 'flex',
      alignItems: 'base-line',
    },
    '@media (max-width: 1650px)': {
      width: 90,
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
    },
    '&': {
      '@media (max-width: 1240px)': {
        display: 'none',
      },
    },
  },
  menuList: {
    Link: {
      sx: {
        display: 'flex',
        alignItems: 'center',
      },
    },
    ListItemButton: {
      sx: {
        '&: hover': {
          borderRadius: '8px',
        },
        alignItems: 'center',
        display: 'flex',
      },
      alignItems: 'center',
    },
    sx: {
      width: '100%',
    },
    title: {
      typography: {
        variant: 'overline',
        color: 'neutral.700',
      },
      font: {
        fontWeight: 600,
      },
    },
    typography: {
      sx: {
        color: 'text.secondary',
      },
      sxDefault: {
        variant: 'body2',
        color: 'text.secondary',
      },
      sxError: {
        variant: 'body2',
        color: 'error.main',
      },
    },
    btn: {
      box: {
        sx: {
          display: 'flex',
          cursor: 'pointer',
          '@media (max-width: 1650px)': {
            justifyContent: 'center',
          },
          width: '100%',
        },
      },
      burger: {
        sx: (expanded: boolean) => {
          if (!expanded) {
            return {
              '& svg': {
                fill: '#EC0982',
              },
            };
          }

          return {
            '& svg': {
              fill: '#6B7280',
            },
          };
        },
      },
      sx: {
        fontSize: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
  },
  backgroundDefault: 'background.default',
  backgroundError: 'rgba(209, 67, 67, 0.12)',
  listItemTextStyle: {
    errorStyle: {
      color: 'error.main',
    },
    defaultStyle: {
      color: 'text.secondary',
    },
  },
  boxSvg: {
    sx: {
      fontSize: 20,
      lineHeight: 20,
      '@media (max-width: 1650px)': {
        width: 60,
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        px: 0,
        '.MuiListItemIcon-root': {
          mr: 0,
        },
        '& svg': {
          display: 'flex',
          alignItems: 'base-line',
          justifyContent: 'center',
        },
      },
    },
  },
  boxListContainer: {
    sx: {
      width: 290,
      display: 'flex',
      alignItems: 'center',
      '@media (max-width: 1650px)': {
        display: 'none',
      },
    },
  },
} as const;
